/**
 * Estilo admin: base neutra + colores semánticos básicos.
 * Verde = OK / éxito · Amarillo = alertas · Rojo = cancelar / eliminar
 */
export const adminColors = {
  bg: 'gray.50',
  surface: 'white',
  border: 'gray.200',
  text: 'gray.800',
  textMuted: 'gray.500',
  primary: '#003064',
  primaryHover: '#004080',
};

export const primaryButtonProps = {
  size: 'sm',
  variant: 'adminPrimary',
};

export const secondaryButtonProps = {
  size: 'sm',
  variant: 'adminSecondary',
};

export const ghostButtonProps = {
  size: 'sm',
  variant: 'adminGhost',
};

export const successButtonProps = {
  size: 'sm',
  variant: 'adminSuccess',
};

export const warningButtonProps = {
  size: 'sm',
  variant: 'adminWarning',
};

/** Acción destructiva (confirmar cancelación, eliminar) */
export const dangerButtonProps = {
  size: 'sm',
  variant: 'adminDanger',
};

/** Cancelar servicio / volver sin confirmar destructivo */
export const dangerOutlineButtonProps = {
  size: 'sm',
  variant: 'adminDangerOutline',
};

const STATUS_BADGE_SCHEMES = {
  Cancelado: 'red',
  Finalizado: 'green',
  Completado: 'green',
  Pendiente: 'yellow',
  Confirmado: 'blue',
  'En curso': 'orange',
  Recepcionado: 'cyan',
};

export const statusBadgeProps = {
  variant: 'subtle',
  colorScheme: 'gray',
  fontSize: 'xs',
  fontWeight: 'medium',
  textTransform: 'none',
  borderRadius: 'md',
  px: 2,
  py: 0.5,
};

export const alertBadgeProps = {
  ...statusBadgeProps,
  colorScheme: 'yellow',
};

export function getStatusBadgeProps(status) {
  const scheme = STATUS_BADGE_SCHEMES[status] || 'gray';
  return { ...statusBadgeProps, colorScheme: scheme };
}

/** Labels compactos en drawers de edición (cliente, vehículo, etc.). */
export const compactFormLabelProps = {
  fontSize: 'xs',
  fontWeight: 'semibold',
  mb: 1,
  color: 'gray.700',
};

export const compactInputProps = {
  size: 'sm',
  variant: 'outline',
  focusBorderColor: 'blue.400',
  borderColor: 'gray.300',
};

export const compactSelectProps = {
  size: 'sm',
  variant: 'outline',
  focusBorderColor: 'blue.400',
  borderColor: 'gray.300',
};
